import type { DrawerProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import type { SideBarProps } from './SideBar.types.js';

export const useSideBarEffects = ({ isNavOpen }: Pick<SideBarProps, 'isNavOpen'>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const drawerOpen = isMobile ? isNavOpen : true;
  const drawerVariant: DrawerProps['variant'] = isMobile
    ? 'persistent'
    : 'permanent';

  return {
    drawerOpen,
    drawerVariant,
  };
};
